'use strict';

var shallow = require('zustand/shallow');

// src/default-shallow.ts
var withDefaultShallow = (storeHook) => {
  function shallowStoreHook(selector, equals) {
    return selector ? storeHook(selector, equals != null ? equals : shallow.shallow) : storeHook();
  }
  shallowStoreHook.getState = storeHook.getState;
  shallowStoreHook.setState = storeHook.setState;
  shallowStoreHook.subscribe = storeHook.subscribe;
  shallowStoreHook.destroy = storeHook.destroy;
  return shallowStoreHook;
};

exports.withDefaultShallow = withDefaultShallow;
